export const columnsNames = [
  { id: "id", value: "Id" },
  { id: "direccion_fiscal", value: "Dirección" },
  { id: "rfc", value: "RFC" },
  { id: "nombre", value: "Nombre" },
  { id: "correo", value: "Correo" },
  { id: "telefono", value: "Teléfono" },
  { id: "tipo_usuario", value: "Permisos" },
  { id: "activo", value: "Estatus" },

  { id: "nombre_ramo", value: "Ramo" },
  { id: "nombre_subramo", value: "Subramo" },

  { id: "nombre_aseguradora", value: "Nombre Aseguradora" },
  { id: "ramo", value: "Ramo" },

  { id: "detalles", value: "Productos" },

  { id: "total_proveedores", value: "Total Proveedores" },
  { id: "proveedores_respondidos", value: "Respondidos" },
  { id: "proveedores_pendientes", value: "Pendientes" },
  { id: "id_requisicion", value: "Requisición" },
  { id: "nombre_creador", value: "Creador" },
  { id: "nombre_usuario", value: "Solicita" },
  { id: "nombre_empresa", value: "Empresa" },
  { id: "created_at", value: "Fecha creación" },
];
